/**
 * NAOKO — Copy discount code on click.
 * Delegated handler — działa dla wszystkich miejsc na stronie (listing, PDP).
 *
 * Markup wspierany:
 *   <div class="pc-card__coupon" data-discount-copy data-discount-code="WOW25">...
 *   <div class="discount-info"   data-discount-copy data-discount-code="WOW25">...   (legacy)
 *
 * Po kliknięciu kopiuje kod do schowka i:
 *   1. dodaje klasę --copied na 1.2s (pc-card__coupon--copied / discount-info--copied),
 *   2. pokazuje własny toast „Skopiowano…" (jednolity iOS/Android).
 *
 * Dlaczego własny toast, a nie systemowy iOS:
 *   iOS Safari NIE pokazuje natywnego dymka „Skopiowano” dla clipboard API
 *   wywoływanego z JS (systemowy toast jest zarezerwowany dla natywnej akcji
 *   „Kopiuj” z menu). Nie da się go wywołać z kodu. Dlatego renderujemy własny
 *   toast, który działa identycznie na iOS i Androidzie.
 *
 * Etykieta: z data-copied-label na tagu <script> (locale coupon.copied),
 * z fallbackiem „Skopiowano!”.
 */
(function () {
  if (window.__naokoDiscountCopyInit) return;
  window.__naokoDiscountCopyInit = true;

  var COPIED_LABEL =
    (document.currentScript && document.currentScript.getAttribute('data-copied-label')) ||
    'Skopiowano!';

  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.top = '0';
    ta.style.left = '0';
    ta.style.width = '1px';
    ta.style.height = '1px';
    ta.style.padding = '0';
    ta.style.border = 'none';
    ta.style.outline = 'none';
    ta.style.boxShadow = 'none';
    ta.style.background = 'transparent';
    ta.style.fontSize = '16px';
    document.body.appendChild(ta);

    var selection = document.getSelection();
    var savedRange = selection && selection.rangeCount > 0 ? selection.getRangeAt(0) : null;

    ta.focus();
    ta.setSelectionRange(0, text.length);

    try {
      document.execCommand('copy');
    } catch (e) {
      /* no-op */
    }

    document.body.removeChild(ta);
    if (selection && savedRange) {
      selection.removeAllRanges();
      selection.addRange(savedRange);
    }
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).catch(function () {
        fallbackCopy(text);
      });
    } else {
      fallbackCopy(text);
    }
  }

  function markCopied(el) {
    el.classList.add('pc-card__coupon--copied', 'discount-info--copied');
    setTimeout(function () {
      el.classList.remove('pc-card__coupon--copied', 'discount-info--copied');
    }, 1200);
  }

  // --- Toast „Skopiowano” (jeden, globalny, re-używany) ---------------------
  var toastEl = null;
  var toastTimer = null;

  function ensureToast() {
    if (toastEl) return toastEl;
    toastEl = document.createElement('div');
    toastEl.className = 'naoko-copy-toast';
    toastEl.setAttribute('role', 'status');
    toastEl.setAttribute('aria-live', 'polite');
    document.body.appendChild(toastEl);
    return toastEl;
  }

  function showToast(message) {
    var el = ensureToast();
    el.textContent = message;
    // reflow, żeby ponowne pokazanie zawsze re-triggerowało animację
    void el.offsetWidth;
    el.classList.add('naoko-copy-toast--visible');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('naoko-copy-toast--visible');
    }, 2500);
  }

  document.addEventListener('click', function (event) {
    var el = event.target.closest('[data-discount-copy]');
    if (!el) return;
    var code = el.getAttribute('data-discount-code');
    if (!code) return;
    copyText(code);
    markCopied(el);
    showToast(COPIED_LABEL);
  });
})();
